import React from 'react';
import Link from 'next/link';

export default function HeroWithBackgroundImage({ block, position }) {
  const {
    background_image,
    text_color_picker,
    background_color_picker,
    bold_title,
    pretext,
    title,
    subtext_utility_anchor,
    subtext,
    button_group,
    _metadata
  } = block.hero_with_background_image;

  let alternateFontBool = false;
  const mobileImage = background_image?.mobile;
  const tabletImage = background_image?.tablet;
  const desktopImage = background_image?.desktop;

  if (pretext.length >= 20 && title.length >= 36) {
    alternateFontBool = true;
  }

  return (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name={'hero_with_background'}
      className={`hero_with_background product-hero-padding relative flex min-h-[288px] w-full justify-center bg-[${background_color_picker}]`}
    >
      {mobileImage && tabletImage && desktopImage && (
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet={`${mobileImage.url}, ${mobileImage.url}?dpr=2 2x`}
          />
          <source
            media="(min-width: 768px) and (max-width: 1024px)"
            srcSet={`${tabletImage.url}, ${tabletImage.url}?dpr=2 2x`}
          />
          <source
            media="(min-width: 1025px)"
            srcSet={`${desktopImage.url}, ${desktopImage.url}?dpr=2 2x`}
          />
          <img
            className="relative min-h-[288px] w-full"
            src={desktopImage.url}
            alt={background_image.image_alt_copy}
            width="2880"
            height="584"
          />
        </picture>
      )}
      <div className="absolute top-0 bottom-0 flex items-center justify-center">
        <div className={`text-[${text_color_picker}] text-center`}>
          {pretext && (
            <span
              className={`preheading-s sm:preheading-r mb-2 block ${alternateFontBool === true ? 'preheading-r' : 'preheading-s'}`}
            >
              {pretext}
            </span>
          )}
          <h1 className={`text-center text-[${text_color_picker}] px-10`}>
            <span
              className={`h3 sm:h2 lg:h1 block ${alternateFontBool === true ? 'sm:h1 mx-auto w-full max-w-[70%] items-center justify-center text-center' : 'h1'} ${bold_title ? 'font-semibold' : 'h3'} `}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </h1>
          <h2
            id={subtext_utility_anchor || ''}
            className={`text-center text-[${text_color_picker}] body-r lg:sh8 mt-4 px-10 ${!subtext ? 'hidden' : ''}`}
            dangerouslySetInnerHTML={{ __html: subtext }}
            aria-hidden={!subtext}
          />
          {button_group?.button_toggle ? (
            <Link href={button_group.redirect_url} prefetch={false}>
              <div className="py-6">
                <button className="btn btn-primary m-auto flex h-12 max-w-md items-center px-24 py-2">
                  {button_group.button_text}
                </button>
              </div>
            </Link>
          ) : (
            ''
          )}
        </div>
      </div>
    </section>
  );
}
